<template>
  <div class="landing-page">
    <NavBar />
    <div class="content">
      <div class="content-top">
        <h1 class="page-title"><span class="title-row title-row-1">What</span><span class="title-row title-row-2">Tech Type</span><span class="title-row title-row-3"><span class="return">↳</span> Am I?</span></h1>
        <form action="about" method="GET">
          <Button
            class="start-button"
            :icon="arrowRightIcon"
          >
            Start quiz
          </Button>
        </form>
      </div>
      <div class="content-bottom">
        <picture>
          <source media="(max-width: 767px)" :srcset="landingPageHeaderSmall" />
          <source media="(min-width: 768px) and (max-width: 1279px)" :srcset="landingPageHeaderMedium" />
          <source media="(min-width: 1280px)" :srcset="landingPageHeaderLarge" />
          <img class="illustration" :src="landingPageHeaderSmall" />
        </picture>
        <span class="collaboration">In collaboration with MyInnerGenius</span>
      </div>
    </div>
  </div>
</template>

<script>
import SKBButton from '@/components/SKBButton'
import SKBNavBar from '@/components/SKBNavBar'

import landingPageHeaderSmall from '@/assets/images/pages/landing_page/landing_page_small.svg'
import landingPageHeaderMedium from '@/assets/images/pages/landing_page/landing_page_medium.svg'
import landingPageHeaderLarge from '@/assets/images/pages/landing_page/landing_page_large.svg'

import arrowRightIcon from '@/assets/images/icons/arrow_right.svg'

export default {
  name: 'LandingPage',
  components: {
    Button: SKBButton,
    NavBar: SKBNavBar
  },
  data () {
    return {
      landingPageHeaderSmall,
      landingPageHeaderMedium,
      landingPageHeaderLarge,
      arrowRightIcon
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  background-color: $blue-100;
  padding: 2rem 1rem 1rem 1rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  h1 {
    color: #fff;
    margin-bottom: 2rem;

    .title-row {
      display: block;
      font-size: 42px;
    }

    .title-row-3 {
      margin-left: 4ch;
    }

    .return {
      color: $blue-60;
    }
  }

  .illustration {
    margin-bottom: 1rem;
    width: 100%;
  }

  .start-button {
    min-width: 100%;
    margin-bottom: 2rem;
  }

  .collaboration {
    display: block;
    color: $grey-10;
    text-align: right;
  }

  @include respond-to(w-42) {
    padding: 3rem 2rem 2rem 1rem;

    .content-top {
      padding: 0 12rem;
    }

    h1 {
      .title-row {
        font-size: 3.375rem;
      }
    }
  }

  .illustration {
    margin-top: -5rem;
  }

  @include respond-to(w-80) {
    padding-top: 4rem;

    .content-top {
      padding: 0 32rem;
    }

    h1 {
      .title-row {
        font-size: 3.75rem;
      }
    }

    .illustration {
      margin-top: -10rem;
    }
  }
}
</style>
